"use client";
import { TagadaProvider } from "@tagadapay/plugin-sdk/v2";
import { Toaster } from "react-hot-toast";

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <TagadaProvider
      environment="production"
      localConfig="default"
      blockUntilSessionReady={true}
      customApiConfig={{
        apiConfig: {
          baseUrl: "https://crm.apptics.ai",
          endpoints: {
            checkout: {
              sessionInit: "/api/v1/checkout/session/init",
              sessionInitAsync: "",
              sessionStatus: "/api/v1/checkout/session/status",
              asyncStatus: "",
            },
            customer: {
              profile: "/api/v1/customer/profile",
              session: "/api/v1/customer/session",
            },
            store: {
              config: "/api/v1/store/config",
            },
          },
        },
      }}
    >
      {children}
      <Toaster position="top-center" />
    </TagadaProvider>
  );
}
